/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-28 15:58:48
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import './index.css'

export default class BsyStepPane extends BsyWidget {

    static defaultProps = {
        baseCls: "bsy-step-pane",
        steps: [],
        currentStep: 0
    }
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        }


        this.element = React.createRef();

    }

    render() {
        const { steps, currentStep } = this.state;
        const { cssName } = this.options;
        return (
            <div className={cssName} ref={this.element} >
                {
                    steps.map((step, index) => {

                        return <div key={"dc" + index}
                            className={"progress-step " + (index <= currentStep ? 'select ' : '') + (currentStep == index ? 'current ' : '')}
                        >
                            <div className="step-message">{step}</div>
                            <span className="step-point"></span>
                            {
                                index > 0 && <div className="step-line"></div>
                            }
                        </div>
                    })
                }

            </div >
        );
    }
}
